import React from 'react'
import styles from './PageHeader.module.css'

type PageHeaderProps = {
  kicker?: React.ReactNode
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({ kicker, title, subtitle, actions, className }) => {
  return (
    <div className={`${styles.pageHeader} ${className || ''}`.trim()}>
      <div className={styles.left}>
        {kicker ? <p className={styles.kicker}>{kicker}</p> : null}
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  )
}

export default PageHeader
